import React from 'react';
import dayjs from 'dayjs';
import { dateAgo, toMillis } from '@utils/dateAgo';
import Tooltip from '@components/dataDisplay/Tooltip';

interface TimeAgoProps {
  createdAt: any;
  showTime?: boolean;
  className?: string;
  prefix?: string;
  suffix?: string;
}

/**
 * 상대 시간 표시 컴포넌트
 * - 호버 시 정확한 날짜/시간을 툴팁으로 표시
 * - dateAgo() 직접 호출을 대체하는 공용 컴포넌트
 */
function TimeAgo({
  createdAt,
  showTime = true,
  className,
  prefix,
  suffix,
}: TimeAgoProps) {
  if (!createdAt) return null;

  const relativeText = dateAgo(createdAt, showTime);
  const ms = toMillis(createdAt);
  const absoluteText = ms
    ? dayjs(ms).format('YYYY.MM.DD HH:mm')
    : '';

  return (
    <Tooltip message={absoluteText} direction="bottom" hidden={!absoluteText}>
      <span className={className}>
        {prefix}
        {relativeText}
        {suffix}
      </span>
    </Tooltip>
  );
}

export default TimeAgo;
